import React from 'react'
import Collection from '../common/collection'

function CollectionZ({ props }) {
  return (
    <Collection
      src={['https://volverse-negro-daniel.s3.amazonaws.com/images/24.+p%C3%A1jaros+c%C3%BApula70.jpg']}
      alt="Pájaros en la cúpula"
    />
  )
}


export default CollectionZ
